import { Formik, Form, Field } from "formik";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const ValidationSchema = Yup.object().shape({
  nombre: Yup.string()
    .min(2, "Ingrese un nombre valido")
    .max(15, "Ingrese un nombre valido")
    .required("Ingrese un nombre valido"),
  apellido: Yup.string()
    .min(2, "Ingrese un apellido valido")
    .max(15, "Ingrese un apellido valido")
    .required("Ingrese un apellido valido"),
  DNI: Yup.number()
    .typeError("Ingresar un DNI valido")
    .required("Ingresar DNI"),
  mail: Yup.string()
    .email("Ingrese un email valido")
    .required("Ingrese un email valido"),
  celular: Yup.string().required("Ingrese su numero de celular"),
  fechaDeNacimiento: Yup.date().required("Ingrese su fecha de nacimiento"),
  concesionario: Yup.string().required("Seleccione un concesionario"),
  fechaDeTestDrive: Yup.string().required("Elija una fecha"),
  horario: Yup.string().required("Elija un horario"),
  TyC: Yup.bool()
    .required()
    .oneOf([true], "Debe aceptar los terminos y condiciones"),
  mayorDeEdad: Yup.bool()
    .required()
    .oneOf([true], "Debe ser mayor de edad y contar con registro vigente"),
  info: Yup.bool(),
});

const KiaForm = () => {
  const [concesionario, setconcesionario] = useState();
  const [fechas, setFechas] = useState();
  const [horarios, setHorarios] = useState();
  const [selectedConcesionario, setSelectedConcesionario] = useState();

  let navigate = useNavigate();

  const server = "https://www.kia.com.ar/mundialqatar2022/integraciones";

  const fireSwal = (errDesc) => {
    Swal.fire({
      title: "Ocurrio un error!",
      text: errDesc,
      icon: "error",
      confirmButtonText: "Reintentar",
    });
  };

  const getconcesionarios = async () => {
    const res = await fetch(server + "/api/concesionarios");
    const json = await res.json();

    return json;
  };

  const getSlotsDisponibles = async (idconcesionario, fecha) => {
    const res = await fetch(server + "/api/slots-disponibles", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fecha: fecha, concesionario: idconcesionario }),
    });

    const json = await res.json();

    return json;
  };

  const getFechasDisponibles = async (concesionario) => {
    const res = await fetch(
      server + `/api/fechas?concesionario=${concesionario}`
    );

    const json = await res.json();

    return json;
  };

  const postReserva = async (values) => {
    const form = {
      nombre: values.nombre,
      apellido: values.apellido,
      dni: values.DNI,
      email: values.mail,
      celular: values.celular,
      fechaNacimiento: values.fechaDeNacimiento,
      aceptaTyC: values.TyC,
      mayorEdad: values.mayorDeEdad,
      optIn: values.info,
      concesionario: values.concesionario,
      idTurno: values.horario,
    };

    const res = await fetch(server + "/api/reservar", {
      method: "POST",

      "Content-Type": "application/json",

      body: JSON.stringify(form),
    });

    const json = await res.json();

    return json;
  };

  const handleconcesionarioChange = (value) => {
    setSelectedConcesionario(value);
    getFechasDisponibles(value).then((res) =>
      setFechas(res.data.fechasDisponibles)
    );
  };

  const handleFechaChange = (value) => {
    getSlotsDisponibles(selectedConcesionario, value).then((res) =>
      setHorarios(res.data.slots)
    );
  };

  useEffect(() => {
    getconcesionarios().then((res) => {
      if (res.status === "OK") {
        setconcesionario(res.data.listado);
      } else {
        alert(res.errDesc);
      }
    });
  }, []);

  const initialFormValues = {
    nombre: "",
    apellido: "",
    DNI: "",
    mail: "",
    fechaDeNacimiento: "",
    celular: "",
    concesionario: "",
    fechaDeTestDrive: "",
    horario: "",
    TyC: false,
    mayorDeEdad: false,
    info: false,
  };

  return (
    <Formik
      initialValues={initialFormValues}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        postReserva(values).then((res) => {
          if (res.status === "KO") {
            fireSwal(res.errDesc);
          } else {
            let laHora = horarios.filter(
              (horario) => horario.id === values.horario
            );
            let elConsecionario = concesionario.filter(
              (unCon) => unCon.id === values.concesionario
            );
            navigate("/thank-you", {
              replace: true,
              state: {
                fecha: values.fechaDeTestDrive,
                hora: laHora[0].horario,
                concesionario: elConsecionario[0].nombre,
              },
            });
          }
        });
      }}
    >
      {({
        errors,
        touched,
        handleChange,
        handleBlur,
        values,
        setFieldValue,
      }) => {
        return (
          <Form>
            <div className="grupo-input">
              <div className="row">
                <div className="col">
                  <label htmlFor="nombre" className="form-label">
                    Nombre
                  </label>
                  <Field
                    className="form-input"
                    name="nombre"
                    placeholder="Nombre"
                    autoComplete="off"
                  />
                  {errors.nombre && touched.nombre ? (
                    <div>
                      <span className="error-message">{errors.nombre}</span>
                    </div>
                  ) : null}
                </div>

                <div className="col">
                  <label htmlFor="apellido" className="form-label">
                    Apellido
                  </label>
                  <Field
                    className="form-input"
                    name="apellido"
                    placeholder="Apellido"
                    autoComplete="off"
                  />
                  {errors.apellido && touched.apellido ? (
                    <span className="error-message">{errors.apellido}</span>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="grupo-input">
              <label htmlFor="DNI" className="form-label">
                DNI
              </label>
              <Field
                className="form-input"
                name="DNI"
                placeholder="Nº de DNI"
                autoComplete="off"
              />
              {errors.DNI && touched.DNI ? (
                <span className="error-message">{errors.DNI}</span>
              ) : null}
            </div>

            <div className="grupo-input">
              <label htmlFor="mail" className="form-label">
                Mail
              </label>
              <Field
                className="form-input"
                name="mail"
                placeholder="nombre@cuenta.com"
                autoComplete="off"
              />
              {errors.mail && touched.mail ? (
                <span className="error-message">{errors.mail}</span>
              ) : null}
            </div>

            <div className="grupo-input">
              <label htmlFor="celular" className="form-label">
                Nº de celular
              </label>
              <Field
                className="form-input"
                name="celular"
                placeholder="+5411555566666"
                autoComplete="off"
              />
              {errors.celular && touched.celular ? (
                <span className="error-message">{errors.celular}</span>
              ) : null}
            </div>

            <div className="grupo-input">
              <label htmlFor="fechaDeNacimiento" className="form-label">
                Fecha de nacimiento
              </label>
              <Field
                className="form-input"
                name="fechaDeNacimiento"
                type="date"
                placeholder="dd-mm-yyyy"
              />
              {errors.fechaDeNacimiento && touched.fechaDeNacimiento ? (
                <span className="error-message">
                  {errors.fechaDeNacimiento}
                </span>
              ) : null}
            </div>

            <div className="grupo-input">
              <label htmlFor="concesionario" className="form-label">
                Concesionario
              </label>
              <br />
              <select
                name="concesionario"
                id=""
                value={values.concesionario}
                onChange={(e) => {
                  handleconcesionarioChange(e.target.value);
                  setFieldValue("concesionario", e.target.value);
                }}
                onBlur={handleBlur}
              >
                <option value="" disabled>
                  Selecciona un concesionario disponible
                </option>
                {concesionario
                  ? concesionario.map((unconcesionario) => (
                      <option
                        key={unconcesionario.id}
                        value={unconcesionario.id}
                      >
                        {unconcesionario.nombre}
                      </option>
                    ))
                  : null}
              </select>
              {errors.concesionario && touched.concesionario ? (
                <span className="error-message">{errors.concesionario}</span>
              ) : null}
            </div>

            {!errors.concesionario && touched.concesionario ? (
              <div className="grupo-input">
                <div className="row">
                  <div className="col">
                    <label htmlFor="fechaDeTestDrive" className="form-label">
                      Fecha de test drive
                    </label>
                    <select
                      name="fechaDeTestDrive"
                      id=""
                      value={values.fechaDeTestDrive}
                      onChange={(e) => {
                        handleFechaChange(e.target.value);
                        setFieldValue("fechaDeTestDrive", e.target.value);
                      }}
                      onBlur={handleBlur}
                    >
                      <option value="" disabled>
                        Selecciona una fecha
                      </option>
                      {fechas
                        ? fechas.map((fecha) => (
                            <option value={fecha.fecha} key={fecha.fecha}>
                              {fecha.fecha}
                            </option>
                          ))
                        : null}
                    </select>
                    {errors.fechaDeTestDrive && touched.fechaDeTestDrive ? (
                      <span className="error-message">
                        {errors.fechaDeTestDrive}
                      </span>
                    ) : null}
                  </div>
                  {!errors.fechaDeTestDrive && touched.fechaDeTestDrive ? (
                    <div className="col">
                      <label htmlFor="horario" className="form-label">
                        Horario
                      </label>
                      <select
                        name="horario"
                        id=""
                        value={values.horario}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <option value="" disabled>
                          Selecciona un horario
                        </option>
                        {horarios
                          ? horarios.map((horario) => (
                              <option value={horario.id} key={horario.id}>
                                {horario.horario}
                              </option>
                            ))
                          : null}
                      </select>
                      {errors.horario && touched.horario ? (
                        <span className="error-message">{errors.horario}</span>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
            <div className="checkbox-group d-flex flex-column">
              <div className="d-flex checkbox align-items-center">
                <Field
                  className="form-checkbox form-check-input"
                  name="TyC"
                  type="checkbox"
                />
                <label htmlFor="info" className="checkbox-label">
                  Acepto los{" "}
                  <a
                    href="./img/bases-y-condiciones.pdf"
                    target={"_blank"}
                    style={{ color: "white" }}
                  >
                    Términos y Condiciones
                  </a>
                </label>
              </div>
              {errors.TyC && touched.TyC ? (
                <span className="error-message" style={{ paddingLeft: "10px" }}>
                  {errors.TyC}
                </span>
              ) : null}
              <div className="d-flex checkbox align-items-center">
                <Field
                  className="form-checkbox form-check-input"
                  name="mayorDeEdad"
                  type="checkbox"
                />
                <label htmlFor="info" className="checkbox-label">
                  Soy mayor de 18 años y tengo registro de conducir vigente.
                </label>
              </div>
              {errors.mayorDeEdad && touched.mayorDeEdad ? (
                <span className="error-message" style={{ paddingLeft: "10px" }}>
                  {errors.mayorDeEdad}
                </span>
              ) : null}
              <div className="d-flex checkbox align-items-center">
                <Field
                  className="form-checkbox form-check-input"
                  name="info"
                  type="checkbox"
                />
                <label htmlFor="info" className="checkbox-label">
                  Acepto recibir información de Kia Argentina.
                </label>
              </div>
            </div>
            <button type="submit" className="btn submit-button">
              Agendar Test Drive
            </button>
          </Form>
        );
      }}
    </Formik>
  );
};

const FormSection = () => {
  return (
    <section className="bg-form form-section">
      <div className="form-title">
        <p>¿Cómo agendo mi Test drive?</p>
        <img src="./img/linea-horizontal.svg" alt="linea celeste" />
      </div>
      <div className="form-text">
        <p>
          En el siguiente formulario elegí el concesionario disponible, la fecha
          y horario de tu conveniencia y completá con tus datos.
        </p>
      </div>
      <div className="form-box">
        <KiaForm />
      </div>
      <div className="form-img">
        <img
          src="./img/form-img.svg"
          alt="Qatar"
          style={{ maxWidth: "100%" }}
        />
        <img
          src="./img/champion.svg"
          alt="Champion"
          style={{ maxWidth: "100%" }}
        />
      </div>
    </section>
  );
};

export default FormSection;
